import script from "./MediaViewerDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaViewerDialog.vue?vue&type=script&setup=true&lang=js"

import "./MediaViewerDialog.vue?vue&type=style&index=0&id=975a8814&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-975a8814"]])

export default __exports__